/* OXS Collection — category filter (client-side, by data-cat) */
(() => {
  const root = document.querySelector('[data-oxs-coll]');
  if (!root) return;
  const chips = root.querySelectorAll('.coll-bar__chip');
  const cards = root.querySelectorAll('.coll-card');
  const countEl = root.querySelector('[data-coll-count]');
  const emptyEl = root.querySelector('.coll-grid__empty');

  const apply = (filter) => {
    let shown = 0;
    cards.forEach((card) => {
      const match = filter === 'all' || card.dataset.cat === filter;
      card.classList.toggle('is-hidden', !match);
      if (match) shown += 1;
    });
    if (countEl) countEl.textContent = shown;
    if (emptyEl) emptyEl.style.display = shown === 0 ? 'block' : 'none';
  };

  chips.forEach((chip) => {
    chip.addEventListener('click', () => {
      chips.forEach((c) => c.classList.remove('is-active'));
      chip.classList.add('is-active');
      apply(chip.dataset.filter);
    });
  });
})();
